<template>
  <div id="ASINsDetailed">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <!-- <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
      <Loader />
    </div>
    <div class="container-fluid mt-2" v-if="viewFSNsDetailedData">
      <!-- <div class="row space-between" v-if="showDetailsLqsData.length == 0">
        <div class="col-12">
          <div class="card mb-2  d-flex justify-content-between flex-row mt-3">
            <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
              Listing Quality Score (LQS) Analysis
            </div>
            <div class="d-flex align-items-center" v-if="viewFSNsDetailedData.length != 0">
              <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                v-if="viewFSNsDetailedData[0].lqs_analysis.product_meta.product_link.includes('www.flipkart.com')">
                <img src="../../../../public/img/IndiaFlag.svg" width="22" class="">
                flipkart.com</span>
              <div class="lastUpdatedDate rounded mr-3" v-if="viewFSNsDetailedData.length != 0">
                <button class="btn">Last Updated: {{ viewFSNsDetailedData[0].timestamp }}</button>
              </div>
              <router-link to="/my-products" style="text-decoration: none; float: right">
                <button style="width: max-content; float: right" class="btn navigationButton" type="button">
                  <i class="fa fa-arrow-left"></i>
                  <span style="font-size: 13px"> Back</span>
                </button>
              </router-link>
            </div>

          </div>
        </div>
      </div>
      <div class="card-deck mt-2" v-if="viewFSNsDetailedData.length != 0 && showDetailsLqsData.length == 0">
        <div class="card">
          <h5 class="borderHeading pb-3">Listing Quality Score</h5>
          <div class="d-flex justify-content-between align-items-center">
            <div class="w-50 mr-4">
              <div>
                <highcharts :options="gaugeChartData"></highcharts>
              </div>
            </div>
            <p class="w-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem totam consectetur fugiat
              inventore id perspiciatis neque temporibus officia magni corporis?</p>
          </div>
        </div>
        <div class="card">
          <h5 class="borderHeading pb-3">Product Description</h5>
          <div class="d-flex">
            <div class="productImgContainer w-25 mr-4">
              <img :src="viewFSNsDetailedData[0].lqs_analysis.product_meta.product_image" alt="product img"
                class="w-100" />
            </div>
            <div class="productHeadingContainer w-75 pt-4">
              <a :href="viewFSNsDetailedData[0].lqs_analysis.product_meta.product_link" target="_blank"
                class="cursor-pointer">{{
                  viewFSNsDetailedData[0].lqs_analysis.product_meta.product_name }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" v-if="showDetailsLqsData.length == 0">
        <div class="col-12">
          <div class="card">
            <h5 class="borderHeading pb-3 mb-3">Listing Quality Score<span class="text-body">: Insights</span></h5>
            <div class="row" v-if="viewFSNsDetailedData.length != 0">
              <div class="col-4">
                <div class="copyBreakdownContainer breakdownSideBorder">
                  <b-btn @click="toggleCollapse1"
                    class="border-0 d-flex justify-content-between align-items-center copyBreakdownHeading w-100 py-3 breakDownHeading">
                    <div>Copy Breakdown</div>
                    <div class="d-flex align-items-center">
                      <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                        breakdownIssuesCalculate(viewFSNsDetailedData[0].lqs_analysis.copy_breakdown) }}
                      </div>
                      <div>
                        <img v-if="isCollapsed1" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                        <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                      </div>
                    </div>
                  </b-btn>
                  <b-collapse :visible="isCollapsed1" class="pb-4">
                    <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                      Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                    <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                      v-for="items in viewFSNsDetailedData[0].lqs_analysis.copy_breakdown">
                      <div class="mr-2">
                        <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                          class="checkIconBreakdown rounded-circle p-1" />
                        <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                          class="crossIconBreakdown rounded-circle p-1" />
                      </div>
                      <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                        <div class="d-flex align-items-center">
                          <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                          <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                            :title="items.info"></i>
                        </div>
                        <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}</p>
                        <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                      </div>
                    </div>
                    <div class="breakdownCollapsedFooter mt-3 d-flex align-items-center justify-content-between p-3">
                      <div class="px-3 py-2">
                        <h5 class="mb-0">1 issue found</h5>
                        <p class="mb-0">Click on the button to fix your issues</p>
                      </div>
                      <button class="text-white rounded border-0">Fix here</button>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="col-4">
                <div class="mediaBreakdownContainer breakdownSideBorder">
                  <b-btn @click="toggleCollapse2"
                    class="border-0 d-flex justify-content-between align-items-center mediaBreakdownHeading w-100 py-3 breakDownHeading">
                    <div>Media Breakdown</div>
                    <div class="d-flex align-items-center">
                      <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                        breakdownIssuesCalculate(viewFSNsDetailedData[0].lqs_analysis.media_breakdown) }}
                      </div>
                      <div>
                        <img v-if="isCollapsed2" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                        <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                      </div>
                    </div>
                  </b-btn>
                  <b-collapse :visible="isCollapsed2" class="pb-4">
                    <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                      Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                    <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                      v-for="items in viewFSNsDetailedData[0].lqs_analysis.media_breakdown">
                      <div class="mr-2">
                        <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                          class="checkIconBreakdown rounded-circle p-1" />
                        <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                          class="crossIconBreakdown rounded-circle p-1" />
                      </div>
                      <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                        <div class="d-flex align-items-center">
                          <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                          <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                            :title="items.info"></i>
                        </div>
                        <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}</p>
                        <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                      </div>
                    </div>
                    <div class="breakdownCollapsedFooter mt-3 d-flex align-items-center justify-content-between p-3">
                      <div class="px-3 py-2">
                        <h5 class="mb-0">1 issue found</h5>
                        <p class="mb-0">Click on the button to fix your issues</p>
                      </div>
                      <button class="text-white rounded border-0">Fix here</button>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="col-4">
                <div class="reviewBreakdownContainer breakdownSideBorder">
                  <b-btn @click="toggleCollapse3"
                    class="border-0 d-flex justify-content-between align-items-center reviewBreakdownHeading w-100 py-3 breakDownHeading">
                    <div>Review Breakdown</div>
                    <div class="d-flex align-items-center">
                      <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                        breakdownIssuesCalculate(viewFSNsDetailedData[0].lqs_analysis.review_breakdown) }}
                      </div>
                      <div>
                        <img v-if="isCollapsed3" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                        <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                      </div>
                    </div>
                  </b-btn>
                  <b-collapse :visible="isCollapsed3" class="pb-4">
                    <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                      Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                    <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                      v-for="items in viewFSNsDetailedData[0].lqs_analysis.review_breakdown">
                      <div class="mr-2">
                        <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                          class="checkIconBreakdown rounded-circle p-1" />
                        <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                          class="crossIconBreakdown rounded-circle p-1" />
                      </div>
                      <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                        <div class="d-flex align-items-center">
                          <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                          <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                            :title="items.info"></i>
                        </div>
                        <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}</p>
                        <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                      </div>
                    </div>
                    <div class="breakdownCollapsedFooter mt-3 d-flex align-items-center justify-content-between p-3">
                      <div class="px-3 py-2">
                        <h5 class="mb-0">1 issue found</h5>
                        <p class="mb-0">Click on the button to fix your issues</p>
                      </div>
                      <button class="text-white rounded border-0">Fix here</button>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showDetailsLqsData.length != 0">
        <div class="row space-between">
          <div class="col-12">
            <div class="card mb-2 d-flex justify-content-between align-items-center flex-row mt-3">
              <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
                <h1 v-if="showDetailsLqsData.length != 0" class="showAsinHeading mb-0">{{
                  showDetailsLqsData[0].fsn }}</h1>
              </div>
              <div class="d-flex align-items-center">
                <div v-if="showDetailsLqsData.length != 0">
                  <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                    v-if="showDetailsLqsData[0].lqs_analysis.product_meta.product_link.includes('www.flipkart.com')">
                    <img src="../../../../public/img/IndiaFlag.svg" width="22" class="">
                    flipkart.com</span>
                </div>
                <div class="lastUpdatedDate rounded mr-3" v-if="showDetailsLqsData.length != 0">
                  <button class="btn">{{ showDetailsLqsData[0].timestamp }}</button>
                </div>
                <router-link to="/lqs-analyser" style="text-decoration: none; float: right">
                  <button style="width: max-content; float: right" class="btn navigationButton" type="button">
                    <i class="fa fa-arrow-left"></i>
                    <span style="font-size: 13px">Back</span>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card-deck mt-2" v-if="showDetailsLqsData.length != 0">
          <div class="card">
            <h5 class="borderHeading pb-3">Listing Quality Score</h5>
            <div class="d-flex justify-content-between align-items-center">
              <div class="w-50 mr-4">
                <div>
                  <highcharts :options="gaugeChartData"></highcharts>
                </div>
              </div>
              <p class="w-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem totam consectetur fugiat
                inventore id perspiciatis neque temporibus officia magni corporis?</p>
            </div>
          </div>
          <div class="card">
            <h5 class="borderHeading pb-3">Product Description</h5>
            <div class="d-flex">
              <div class="productImgContainer w-25 mr-4">
                <img :src="showDetailsLqsData[0].lqs_analysis.product_meta.product_image" alt="product img"
                  class="w-100" />
              </div>
              <div class="productHeadingContainer w-75 pt-4">
                <a :href="showDetailsLqsData[0].lqs_analysis.product_meta.product_link" target="_blanck"
                  class="cursor-pointer">{{
                    showDetailsLqsData[0].lqs_analysis.product_meta.product_name }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <div class="card">
              <h5 class="borderHeading pb-3 mb-3">Listing Quality Score<span class="text-body">: Insights</span></h5>
              <div class="row" v-if="showDetailsLqsData.length != 0">
                <div class="col-4">
                  <div class="copyBreakdownContainer breakdownSideBorder">
                    <b-btn @click="toggleCollapse1"
                      class="border-0 d-flex justify-content-between align-items-center copyBreakdownHeading w-100 py-3 breakDownHeading">
                      <div>Copy Breakdown</div>
                      <div class="d-flex align-items-center">
                        <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                          breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.copy_breakdown) }}
                        </div>
                        <div>
                          <img v-if="isCollapsed1" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                          <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                        </div>
                      </div>
                    </b-btn>
                    <b-collapse :visible="isCollapsed1" class="pb-4">
                      <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                        Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                      <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                        v-for="items in showDetailsLqsData[0].lqs_analysis.copy_breakdown">
                        <div class="mr-2">
                          <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                            class="checkIconBreakdown rounded-circle p-1" />
                          <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                            class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                        <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                          <div class="d-flex align-items-center">
                            <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                            <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                              :title="items.info"></i>
                          </div>
                          <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}
                          </p>
                          <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                        </div>
                      </div>
                      <div class="breakdownCollapsedFooter mt-3 d-flex align-items-center justify-content-between p-3">
                      <div class="px-3 py-2">
                        <h5 class="mb-0">1 issue found</h5>
                        <p class="mb-0">Click on the button to fix your issues</p>
                      </div>
                      <button class="text-white rounded border-0">Fix here</button>
                    </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="col-4">
                  <div class="mediaBreakdownContainer breakdownSideBorder">
                    <b-btn @click="toggleCollapse2"
                      class="border-0 d-flex justify-content-between align-items-center mediaBreakdownHeading w-100 py-3 breakDownHeading">
                      <div>Media Breakdown</div>
                      <div class="d-flex align-items-center">
                        <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                          breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.media_breakdown) }}
                        </div>
                        <div>
                          <img v-if="isCollapsed2" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                          <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                        </div>
                      </div>
                    </b-btn>
                    <b-collapse :visible="isCollapsed2" class="pb-4">
                      <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                        Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                      <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                        v-for="items in showDetailsLqsData[0].lqs_analysis.media_breakdown">
                        <div class="mr-2">
                          <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                            class="checkIconBreakdown rounded-circle p-1" />
                          <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                            class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                        <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                          <div class="d-flex align-items-center">
                            <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                            <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                              :title="items.info"></i>
                          </div>
                          <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}
                          </p>
                          <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="col-4">
                  <div class="reviewBreakdownContainer breakdownSideBorder">
                    <b-btn @click="toggleCollapse3"
                      class="border-0 d-flex justify-content-between align-items-center reviewBreakdownHeading w-100 py-3 breakDownHeading">
                      <div>Review Breakdown</div>
                      <div class="d-flex align-items-center">
                        <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                          breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.review_breakdown) }}
                        </div>
                        <div>
                          <img v-if="isCollapsed3" src="Icons_SVG/upArrowLQS.svg" alt="" srcset="" height="10">
                          <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset="" height="10">
                        </div>
                      </div>
                    </b-btn>
                    <b-collapse :visible="isCollapsed3" class="pb-4">
                      <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet, consectetur adipiscing
                        Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                      <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                        v-for="items in showDetailsLqsData[0].lqs_analysis.review_breakdown">
                        <div class="mr-2">
                          <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
                            class="checkIconBreakdown rounded-circle p-1" />
                          <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                            class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                        <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                          <div class="d-flex align-items-center">
                            <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{ items.label }}</h5>
                            <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
                              :title="items.info"></i>
                          </div>
                          <p class="mb-0" v-if="Array.isArray(items.current)">Current : {{ items.current.join(', ') }}
                          </p>
                          <p class="mb-0" v-else-if="items.current">Current : {{ items.current }}</p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" v-if="checkHasMultiple()">
        <div class="col-12">
          <div class="card">
            <h5 class="borderHeading pb-3 mb-3">History</h5>
            <div class="rounded mb-3" v-for="(items, month) in storeLqsDataByMonthGroup">
              <h3 class="monthNameHeading">{{ month }}</h3>
              <div v-for="data in items" class="historyBorder d-flex mt-3 rounded">
                <div class="historyDate p-3 d-flex justify-content-center align-items-center text-center">{{
                  data.timestamp.split(',')[1] }}</div>
                <div class="p-3 d-flex justify-content-between align-items-center w-100">
                  <div>Listing Score : {{ data.total }}</div>
                  <div>Copy Breakdown : {{ breakdownIssuesCalculate(data.lqs_analysis.copy_breakdown) }} <span
                      style="color: #000; font-weight:500">Issues</span></div>
                  <div>Media Breakdown : {{ breakdownIssuesCalculate(data.lqs_analysis.media_breakdown) }} <span
                      style="color: #000; font-weight:500">Issues</span></div>
                  <div>Review Breakdown : {{ breakdownIssuesCalculate(data.lqs_analysis.review_breakdown) }}
                    <span style="color: #000; font-weight:500">Issues</span>
                  </div>
                  <button class="btn primarycolorShow" @click="historyDetailsData(data)">Show Details</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="row mt-2">
        <div class="col-12">
          <div class="card" v-for="(data, i) of viewFSNsDetailedData" :key="'lqsgraph' + i">
            <FlipkartLqsCard :lqsHeading="false" :viewLqsListingdata="data.lqs_analysis" :timestamp="data.timestamp"
              :fsnData="data.fsn" :viewLqsGraph="data.total" />
          </div>
        </div>
      </div> -->
      <FlipkartLqsCard :viewFSNsDetailedData="viewFSNsDetailedData" :storeLqsDataByMonthGroup="storeLqsDataByMonthGroup"
        ref="childComp" :keyCheck="true" />
      <div class="card" v-if="viewFSNsDetailedData.length == 0">
        <div class="noData text-center text-danger">No Data Available.</div>
      </div>

    </div>
    <div v-else class="no-data">No Data!</div>
  </div>
</template>

<script>
import Loader from "../../Components/Loader.vue";
import FlipkartLqsCard from "./FlipkartLqsCard.vue";

export default {
  name: "LqsAnalyser",
  components: { FlipkartLqsCard, Loader },

  data: function () {
    return {
      viewFSNsDetailedData: [],
      FSNId: this.$route.params.FSN,
      loader: false,
      // gaugeChartData: {},
      storeLqsDataByMonthGroup: null,
    };
  },

  mounted() {
    this.getASINsDetails();
  },
  methods: {
    getASINsDetails() {
      let self = this;
      self.loader = true;
      let payload = {
        fsn: this.FSNId,
        start: this.$route.params.startDate,
        end: this.$route.params.endDate,
      };
      const url = "/api/v2/spider/viewfsn";
      self.$http
        .post(url, payload)
        .then((response) => {
          // if (Object.keys(response.data).length)
          self.viewFSNsDetailedData = response.data.data;
          this.storeLqsDataByMonthGroup = null;
          this.storeLqsDataByMonthGroup = this.sortAndGroupByMonth(response.data.data.slice(1));
          this.$refs.childComp.gaugeChart(response.data.data[0].total);
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          console.log("err");
        });
    },
    sortAndGroupByMonth(data) {
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      data.forEach(item => {
        const date = new Date(item.timestamp);
        item.monthIndex = date.getMonth();
      });
      data.sort((a, b) => a.monthIndex - b.monthIndex);
      const groupedData = {};
      data.forEach(item => {
        const monthName = monthNames[item.monthIndex];
        if (!groupedData[monthName]) {
          groupedData[monthName] = [];
        }
        groupedData[monthName].push(item);
      });
      return groupedData;
    },

  },
};
</script>

<style scoped>
.space-between {
  display: flex;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  justify-content: start;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox {
  height: 30px;
  border: 1px solid silver;
  display: flex;
  justify-content: start;
  background: white;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

.falseIcon {
  color: #ff0000 !important;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.productImg {
  width: 200px;
}

.product-title {
  font-size: 18px;
}

.productImg img {
  width: 100%;
}

.graphCount {
  font-size: 24px;
  color: "#533a79";
  font-weight: 700;
}

.asinBadge {
  background: "#9683b3";
}

.cross-icon {
  color: black;
  background: white;
}

.crossIcon {
  cursor: pointer;
  font-size: 8px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

thead {
  background: none;
  font-family: sans-serif;
  background: #9683b3;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

tbody {
  font-family: sans-serif;
  font-size: 13px;
}

.pinkColor {
  background: rgb(255 185 185);
  font-weight: bold;
}

.skyColor {
  background: rgb(199 224 255);
  font-weight: bold;
}

.no-data {
  font-size: 16px;
  text-align: center;
  padding: 10px;
  color: red;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}
</style>
